module.exports = __webpack_public_path__ + "img/download-icon.2e95c8a9.svg";